import React, {useContext} from 'react';
import Money from '../../../lib/Money';
import {CartConfigContext} from "../../../contexts/CartConfigContext";

// 2023-11 modernised
export default function GridItemDesc({item}) {
  let usd = new Money(item.price);

  // 2025-02 this is now dynamic, added flags to back-end data

  return (
    <ul className="list-none text-sm leading-tight">
      <li className="">From {usd.toString()}</li>
    </ul>
  );
}

/* removed:



 {freeShipping ?
 <li className="text-brand-primary">Free Shipping</li> :
 <li>&nbsp;</li>
 }

 */
